// This file is generated from blueprint/admin-frontend/spec/admin-route-registry.json.
// Do not edit manually.

export const generatedRouteRegistry = [
  {
    "componentKey": "dashboard",
    "path": "/dashboard",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.dashboard.title",
    "permissions": [],
    "featureFlag": null,
    "activeMenuCode": "dashboard"
  },
  {
    "componentKey": "system.settings.configs",
    "path": "/system/settings/configs",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.settings.configs.title",
    "permissions": [
      "sys.config.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.settings.configs"
  },
  {
    "componentKey": "system.settings.dictionaries",
    "path": "/system/settings/dictionaries",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.settings.dictionaries.title",
    "permissions": [
      "sys.dictionary.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.settings.dictionaries"
  },
  {
    "componentKey": "system.settings.share-configs",
    "path": "/system/settings/share-configs",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.settings.share_configs.title",
    "permissions": [
      "sys.share_config.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.settings.share-configs"
  },
  {
    "componentKey": "system.settings.login-providers",
    "path": "/system/settings/login-providers",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.settings.login_providers.title",
    "permissions": [
      "sys.login_provider_config.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.settings.login-providers"
  },
  {
    "componentKey": "system.settings.regions",
    "path": "/system/settings/regions",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.settings.regions.title",
    "permissions": [
      "sys.region.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.settings.regions"
  },
  {
    "componentKey": "system.users.departments",
    "path": "/system/users/departments",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.users.departments.title",
    "permissions": [
      "org.unit.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.users.departments"
  },
  {
    "componentKey": "system.users.accounts",
    "path": "/system/users/accounts",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.users.accounts.title",
    "permissions": [
      "iam.user.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.users.accounts"
  },
  {
    "componentKey": "system.users.positions",
    "path": "/system/users/positions",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.users.positions.title",
    "permissions": [
      "org.position.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.users.positions"
  },
  {
    "componentKey": "system.users.tenants",
    "path": "/system/users/tenants",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.users.tenants.title",
    "permissions": [
      "iam.tenant.read"
    ],
    "featureFlag": "multi_tenant",
    "activeMenuCode": "system.users.tenants"
  },
  {
    "componentKey": "system.access.roles",
    "path": "/system/access/roles",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.access.roles.title",
    "permissions": [
      "iam.role.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.access.roles"
  },
  {
    "componentKey": "system.access.permissions",
    "path": "/system/access/permissions",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.access.permissions.title",
    "permissions": [
      "iam.permission.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.access.permissions"
  },
  {
    "componentKey": "system.access.menus",
    "path": "/system/access/menus",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.access.menus.title",
    "permissions": [
      "sys.menu.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.access.menus"
  },
  {
    "componentKey": "system.storage.files",
    "path": "/system/storage/files",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.storage.files.title",
    "permissions": [
      "storage.file.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.storage.files"
  },
  {
    "componentKey": "system.notifications.notices",
    "path": "/system/notifications/notices",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.notices.title",
    "permissions": [
      "notify.notice.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.notices"
  },
  {
    "componentKey": "system.notifications.messages",
    "path": "/system/notifications/messages",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.messages.title",
    "permissions": [
      "notify.message.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.messages"
  },
  {
    "componentKey": "system.notifications.templates",
    "path": "/system/notifications/templates",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.templates.title",
    "permissions": [
      "notify.template.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.templates"
  },
  {
    "componentKey": "system.notifications.deliveries",
    "path": "/system/notifications/deliveries",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.deliveries.title",
    "permissions": [
      "notify.delivery.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.operations"
  },
  {
    "componentKey": "system.notifications.operations",
    "path": "/system/notifications/operations",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.operations.title",
    "permissions": [
      "notify.observability.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.operations"
  },
  {
    "componentKey": "system.notifications.push-channels",
    "path": "/system/notifications/push-channels",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.push_channels.title",
    "permissions": [
      "notify.push_provider.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.push-channels"
  },
  {
    "componentKey": "system.integrations.schedules",
    "path": "/system/integrations/schedules",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.integrations.schedules.title",
    "permissions": [
      "jobs.schedule.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.integrations.schedules"
  },
  {
    "componentKey": "system.integrations.api-clients",
    "path": "/system/integrations/api-clients",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.integrations.api-clients.title",
    "permissions": [
      "sys.api_client.read"
    ],
    "featureFlag": "api_clients",
    "activeMenuCode": "system.integrations.api-clients"
  },
  {
    "componentKey": "system.integrations.webhooks",
    "path": "/system/integrations/webhooks",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.integrations.webhooks.title",
    "permissions": [
      "sys.webhook.read"
    ],
    "featureFlag": "webhooks",
    "activeMenuCode": "system.integrations.webhooks"
  },
  {
    "componentKey": "system.security.operation-logs",
    "path": "/system/security/operation-logs",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.security.operation-logs.title",
    "permissions": [
      "audit.operation.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.security.operation-logs"
  },
  {
    "componentKey": "system.security.login-logs",
    "path": "/system/security/login-logs",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.security.login-logs.title",
    "permissions": [
      "audit.login.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.security.login-logs"
  },
  {
    "componentKey": "system.security.events",
    "path": "/system/security/events",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.security.events.title",
    "permissions": [
      "audit.security.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.security.events"
  },
  {
    "componentKey": "system.security.block-rules",
    "path": "/system/security/block-rules",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.security.block-rules.title",
    "permissions": [
      "iam.block_rule.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.security.block-rules"
  },
  {
    "componentKey": "system.monitoring.sessions",
    "path": "/system/monitoring/sessions",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.monitoring.sessions.title",
    "permissions": [
      "iam.session.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.monitoring.sessions"
  },
  {
    "componentKey": "system.monitoring.health",
    "path": "/system/monitoring/health",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.monitoring.health.title",
    "permissions": [
      "ops.health.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.monitoring.health"
  },
  {
    "componentKey": "system.content.articles",
    "path": "/system/content/articles",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.content.articles.title",
    "permissions": [
      "content.article.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.content.articles"
  },
  {
    "componentKey": "system.content.categories",
    "path": "/system/content/categories",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.content.categories.title",
    "permissions": [
      "content.category.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.content.categories"
  },
  {
    "componentKey": "system.mobile.releases",
    "path": "/system/mobile/releases",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.mobile.releases.title",
    "permissions": [
      "mobile.release.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.mobile.releases"
  },
  {
    "componentKey": "app.applications",
    "path": "/app/applications",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.applications.title",
    "permissions": [
      "app.application.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.applications"
  },
  {
    "componentKey": "app.upgrade-center",
    "path": "/app/upgrade-center",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.upgrade_center.title",
    "permissions": [
      "mobile.release.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.upgrade-center"
  },
  {
    "componentKey": "app.users",
    "path": "/app/users",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.users.title",
    "permissions": [
      "app.user.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.users"
  },
  {
    "componentKey": "app.content.articles",
    "path": "/app/content/articles",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.content.articles.title",
    "permissions": [
      "app.content.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.content.articles"
  },
  {
    "componentKey": "app.content.pages",
    "path": "/app/content/pages",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.content.pages.title",
    "permissions": [
      "app.content.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.content.pages"
  },
  {
    "componentKey": "app.content.categories",
    "path": "/app/content/categories",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.content.articles.title",
    "permissions": [
      "app.content.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.content.articles"
  },
  {
    "componentKey": "profile.basic",
    "path": "/profile/basic",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.profile.basic.title",
    "permissions": [],
    "featureFlag": null,
    "activeMenuCode": null
  },
  {
    "componentKey": "profile.security",
    "path": "/profile/security",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.profile.security.title",
    "permissions": [
      "iam.session.read_self",
      "iam.device.read_self"
    ],
    "featureFlag": null,
    "activeMenuCode": null
  },
  {
    "componentKey": "profile.connections",
    "path": "/profile/connections",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.profile.connections.title",
    "permissions": [
      "iam.oauth.manage_self"
    ],
    "featureFlag": "oauth",
    "activeMenuCode": null
  },
  {
    "componentKey": "system.users.account-detail",
    "path": "/system/users/accounts/$userId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.users.account-detail.title",
    "permissions": [
      "iam.user.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.users.accounts"
  },
  {
    "componentKey": "system.users.tenant-detail",
    "path": "/system/users/tenants/$tenantId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.users.tenant-detail.title",
    "permissions": [
      "iam.tenant.read"
    ],
    "featureFlag": "multi_tenant",
    "activeMenuCode": "system.users.tenants"
  },
  {
    "componentKey": "system.access.role-detail",
    "path": "/system/access/roles/$roleId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.access.role-detail.title",
    "permissions": [
      "iam.role.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.access.roles"
  },
  {
    "componentKey": "system.storage.file-detail",
    "path": "/system/storage/files/$fileId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.storage.file-detail.title",
    "permissions": [
      "storage.file.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.storage.files"
  },
  {
    "componentKey": "system.notifications.notice-detail",
    "path": "/system/notifications/notices/$noticeId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.notice-detail.title",
    "permissions": [
      "notify.notice.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.notices"
  },
  {
    "componentKey": "system.notifications.message-detail",
    "path": "/system/notifications/messages/$messageId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.notifications.message-detail.title",
    "permissions": [
      "notify.message.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.notifications.messages"
  },
  {
    "componentKey": "system.integrations.schedule-runs",
    "path": "/system/integrations/schedules/$scheduleId/runs",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.integrations.schedule-runs.title",
    "permissions": [
      "jobs.run.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.integrations.schedules"
  },
  {
    "componentKey": "system.integrations.api-client-detail",
    "path": "/system/integrations/api-clients/$clientId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.integrations.api-client-detail.title",
    "permissions": [
      "sys.api_client.read"
    ],
    "featureFlag": "api_clients",
    "activeMenuCode": "system.integrations.api-clients"
  },
  {
    "componentKey": "system.integrations.webhook-deliveries",
    "path": "/system/integrations/webhooks/$webhookId/deliveries",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.integrations.webhook-deliveries.title",
    "permissions": [
      "sys.webhook.delivery.read"
    ],
    "featureFlag": "webhooks",
    "activeMenuCode": "system.integrations.webhooks"
  },
  {
    "componentKey": "system.security.event-detail",
    "path": "/system/security/events/$eventId",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.security.event-detail.title",
    "permissions": [
      "audit.security.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "system.security.events"
  },
  {
    "componentKey": "auth.login",
    "path": "/login",
    "auth": "anonymous_or_callback",
    "layout": "auth",
    "titleKey": "routes.auth.login.title",
    "permissions": [],
    "featureFlag": null,
    "activeMenuCode": null
  },
  {
    "componentKey": "auth.register",
    "path": "/register",
    "auth": "anonymous_or_callback",
    "layout": "auth",
    "titleKey": "routes.auth.register.title",
    "permissions": [],
    "featureFlag": "admin_registration",
    "activeMenuCode": null
  },
  {
    "componentKey": "auth.forgot-password",
    "path": "/forgot-password",
    "auth": "anonymous_or_callback",
    "layout": "auth",
    "titleKey": "routes.auth.forgot-password.title",
    "permissions": [],
    "featureFlag": "password_recovery",
    "activeMenuCode": null
  },
  {
    "componentKey": "auth.reset-password",
    "path": "/reset-password",
    "auth": "anonymous_or_callback",
    "layout": "auth",
    "titleKey": "routes.auth.reset-password.title",
    "permissions": [],
    "featureFlag": "password_recovery",
    "activeMenuCode": null
  },
  {
    "componentKey": "auth.oauth-callback",
    "path": "/auth/callback/$provider",
    "auth": "anonymous_or_callback",
    "layout": "auth",
    "titleKey": "routes.auth.oauth-callback.title",
    "permissions": [],
    "featureFlag": "oauth",
    "activeMenuCode": null
  },
  {
    "componentKey": "errors.forbidden",
    "path": "/403",
    "auth": "public",
    "layout": "plain",
    "titleKey": "routes.errors.forbidden.title",
    "permissions": [],
    "featureFlag": null,
    "activeMenuCode": null
  },
  {
    "componentKey": "errors.not-found",
    "path": "/404",
    "auth": "public",
    "layout": "plain",
    "titleKey": "routes.errors.not-found.title",
    "permissions": [],
    "featureFlag": null,
    "activeMenuCode": null
  },
  {
    "componentKey": "errors.server-error",
    "path": "/500",
    "auth": "public",
    "layout": "plain",
    "titleKey": "routes.errors.server-error.title",
    "permissions": [],
    "featureFlag": null,
    "activeMenuCode": null
  },
  {
    "componentKey": "errors.offline",
    "path": "/offline",
    "auth": "public",
    "layout": "plain",
    "titleKey": "routes.errors.offline.title",
    "permissions": [],
    "featureFlag": null,
    "activeMenuCode": null
  },
  {
    "componentKey": "app.feedbacks",
    "path": "/app/feedbacks",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.feedbacks.title",
    "permissions": [
      "app.feedback.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.feedbacks"
  },
  {
    "componentKey": "system.ai.providers",
    "path": "/system/ai/providers",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.ai.providers.title",
    "permissions": [
      "ai.provider.read"
    ],
    "featureFlag": "ai",
    "activeMenuCode": "system.ai.providers"
  },
  {
    "componentKey": "system.ai.models",
    "path": "/system/ai/models",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.ai.models.title",
    "permissions": [
      "ai.model.read"
    ],
    "featureFlag": "ai",
    "activeMenuCode": "system.ai.models"
  },
  {
    "componentKey": "system.ai.access",
    "path": "/system/ai/access",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.ai.access.title",
    "permissions": [
      "ai.access.read"
    ],
    "featureFlag": "ai",
    "activeMenuCode": "system.ai.access"
  },
  {
    "componentKey": "system.ai.playground",
    "path": "/system/ai/playground",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.ai.playground.title",
    "permissions": [
      "ai.invoke"
    ],
    "featureFlag": "ai",
    "activeMenuCode": "system.ai.playground"
  },
  {
    "componentKey": "system.ai.usage",
    "path": "/system/ai/usage",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.system.ai.usage.title",
    "permissions": [
      "ai.usage.read"
    ],
    "featureFlag": "ai",
    "activeMenuCode": "system.ai.usage"
  },
  {
    "componentKey": "app.support.inbox",
    "path": "/app/support/inbox",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.support.inbox.title",
    "permissions": [
      "support.conversation.read"
    ],
    "featureFlag": "support",
    "activeMenuCode": "app.support.inbox"
  },
  {
    "componentKey": "app.support.sites",
    "path": "/app/support/sites",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.support.sites.title",
    "permissions": [
      "support.config.read"
    ],
    "featureFlag": "support",
    "activeMenuCode": "app.support.sites"
  },
  {
    "componentKey": "app.support.characters",
    "path": "/app/support/characters",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.support.characters.title",
    "permissions": [
      "support.config.read"
    ],
    "featureFlag": "support",
    "activeMenuCode": "app.support.characters"
  },
  {
    "componentKey": "app.support.products",
    "path": "/app/support/products",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.support.products.title",
    "permissions": [
      "support.config.read"
    ],
    "featureFlag": "support",
    "activeMenuCode": "app.support.products"
  },
  {
    "componentKey": "app.support.faq",
    "path": "/app/support/faq",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.support.faq.title",
    "permissions": [
      "support.config.read"
    ],
    "featureFlag": "support",
    "activeMenuCode": "app.support.faq"
  },
  {
    "componentKey": "app.support.settings",
    "path": "/app/support/settings",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.support.settings.title",
    "permissions": [
      "support.config.read"
    ],
    "featureFlag": "support",
    "activeMenuCode": "app.support.settings"
  },
  {
    "componentKey": "app.commerce",
    "path": "/app/commerce",
    "auth": "required",
    "layout": "app",
    "titleKey": "routes.app.commerce.title",
    "permissions": [
      "commerce.products.read"
    ],
    "featureFlag": null,
    "activeMenuCode": "app.commerce"
  }
] as const
